let pink01  = [0.96, 0.64, 0.88, 1.0];
let purple01= [0.70, 0.46, 0.94, 1.0];
let blue01  = [0.43, 0.79, 0.97, 1.0];
let green01 = [0.49, 0.89, 0.41, 1.0];
let yellow01= [1.00, 0.87, 0.20, 1.0];
let red01   = [1.00, 0.50, 0.50, 1.0];

export {
    pink01,
    purple01,
    blue01,
    green01,
    yellow01,
    red01,
}
